import { AuthRoutes } from './type'

const root = `${AuthRoutes.root}`
const login = `${root}/${AuthRoutes.login}`
const forgot = `${root}/${AuthRoutes.forgot}`
const oauth = `${root}/${AuthRoutes.oauth}`

const passwordChangeForce = `${root}/${AuthRoutes.passwordChangeForce}`

export const AuthPath = {
  root: root,
  login: login,
  forgot: forgot,
  oauth: oauth,
  passwordChangeForce: passwordChangeForce,
}
